import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header__main__mega" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row row-mega no-gutters io-eq" }
const _hoisted_6 = { class: "row no-gutters" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseHeaderMegaMenu',
  props: {
  parent: {
    type: Object,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h5", {
          class: "text-regular",
          innerHTML: __props.parent.subtitle || __props.parent.title
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (menuItem) => {
            return (_openBlock(), _createElementBlock("div", {
              key: menuItem.id,
              class: "eq-object pb-3"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
                _createVNode(_component_IoRouterLink, {
                  "link-url": menuItem.url,
                  "link-target": menuItem.target,
                  "link-title": menuItem.titleAttr,
                  active: menuItem.active
                }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-mega-image" }, null, -1)),
                    _createElementVNode("span", {
                      class: "row-mega-title",
                      "data-eq-part": "title",
                      innerHTML: menuItem.title || ''
                    }, null, 8, _hoisted_7),
                    _createElementVNode("span", {
                      class: "row-mega-subtitle",
                      "data-eq-part": "subtitle",
                      innerHTML: menuItem.subtitle || ''
                    }, null, 8, _hoisted_8)
                  ]),
                  _: 2
                }, 1032, ["link-url", "link-target", "link-title", "active"]),
                _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})